export const ORIGIN_COLORS: Record<string, string> = {
  airbnb: "bg-red-100 text-red-800 hover:bg-red-200",
  "airbnb.com": "bg-red-100 text-red-800 hover:bg-red-200",
  booking: "bg-blue-100 text-blue-800 hover:bg-blue-200",
  "booking.com": "bg-blue-100 text-blue-800 hover:bg-blue-200",
  "estancia corta": "bg-brand-primary text-white hover:bg-brand-primary-hover",
  "reservas directas": "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
  directo: "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
  "redes sociales": "bg-green-200 text-green-900 hover:bg-green-300",
  referencia: "bg-purple-200 text-purple-900 hover:bg-purple-300",
  otro: "bg-gray-300 text-gray-800 hover:bg-gray-400",
  default: "bg-gray-200 text-gray-800 hover:bg-gray-300",
};

export const ORIGIN_DOT_COLORS: Record<string, string> = {
  airbnb: "bg-red-400",
  "airbnb.com": "bg-red-400",
  booking: "bg-blue-400",
  "booking.com": "bg-blue-400",
  "estancia corta": "bg-brand-primary",
  "reservas directas": "bg-teal-400",
  directo: "bg-teal-400",
  "redes sociales": "bg-green-500",
  referencia: "bg-purple-400",
  otro: "bg-gray-400",
  default: "bg-gray-500",
};

